<template>
  <div>
    <div class="mb-5">
      <div class="font-weight-bold font-size-18">
        Маршрут візування договору
      </div>
      <div class="text-disabled">
        Послідовний маршрут погодження · {{ routes.length }} етапи
      </div>
    </div>

    <div
      v-for="route in routes"
      :key="route.id"
      class="d-flex ga-4 route-group">
      <div>
        <v-avatar color="blue-lighten-5" size="36">
          <span class="font-weight-bold text-blue-darken-3">
            {{ route.queueNumber }}
          </span>
        </v-avatar>
        <!--        <v-avatar v-else color="deep-purple-lighten-5" size="36">-->
        <!--          <v-icon-->
        <!--            icon="mdi-account-multiple-outline"-->
        <!--            color="deep-purple-darken-1"-->
        <!--            size="20"></v-icon>-->
        <!--        </v-avatar>-->
      </div>

      <div class="w-100 pb-6">
        <div class="d-flex align-center ga-3 mb-1">
          <span class="font-weight-bold font-size-15">{{ route.name }}</span>

          <v-chip
            v-if="route.users.length === 1"
            color="blue-darken-2"
            variant="tonal"
            density="compact"
            rounded="lg"
            class="font-weight-bold text-uppercase">
            Одна особа
          </v-chip>
          <v-chip
            v-else
            color="deep-purple"
            variant="tonal"
            density="compact"
            rounded="lg"
            class="font-weight-bold text-uppercase">
            Група · {{ route.users.length }} особи
          </v-chip>
        </div>

        <!-- один учасник у групі -->
        <template v-if="route.users.length === 1">
          <div class="font-size-14">
            {{ getPersonName(route.users[0].user) }}
          </div>
          <div class="text-disabled font-size-13">
            {{ route.users[0].user.post }}
          </div>
        </template>

        <!-- декілька учасників у групі -->
        <template v-else>
          <div class="text-disabled mb-3">
            {{ route.action?.name }} | {{ route.agreement.name }}
          </div>

          <div class="d-flex flex-column ga-2">
            <div
              v-for="user in route.users"
              :key="user.id"
              class="d-flex align-center ga-3 pa-3 rounded-lg bg-grey-lighten-4">
              <v-avatar color="grey-lighten-2" size="36">
                <span class="font-weight-bold text-grey-darken-2">
                  {{ user.user.surname?.[0] }}
                </span>
              </v-avatar>

              <div>
                <div class="font-weight-bold font-size-14">
                  {{ getPersonName(user.user) }}
                </div>
                <div class="text-disabled font-size-13">
                  {{ user.user.post }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="!routes.length" class="text-disabled text-center">
      Дані відсутні
    </div>
  </div>
</template>

<script setup lang="ts">
import { getPersonName } from 'best-modules/utils'
import { useDocumentAgreement } from '../../documentAgreement'

defineOptions({
  name: 'TemplateRoutes',
})

const { routes } = useDocumentAgreement()
</script>

<style scoped lang="scss">
.route-group {
  position: relative;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    width: 2px;
    height: calc(100% - 36px);
    background: #dfdfdf;
    top: 36px;
    left: 17px;
  }
}
</style>
